<template>
  <div>
    <div class="tou">
      <div class="icon">
        <div @click="onClickLeft"><van-icon name="arrow-left" size="24" /></div>
        <div @click="home"><van-icon name="wap-home" size="24"/></div>
      </div>
      <div class="t">
        {{title}}
      </div>
    </div>
    <!-- <nav-bar @click-left="onClickLeft" :title="title" left-arrow></nav-bar> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { NavBar } from "vant";
import { goBack, getStorage, removeStorage } from "@/libs/utils";
export default {
  name: "Main",
  components: {
    NavBar
  },
  methods: {
    onClickLeft: function(e) {
      if (getStorage("replace")) {
        goBack("index");
        removeStorage("replace");
      } else {
        goBack();
      }
    },
    home: function() {
      this.$router.push({
          name: "index"
      });
    }
  },
  computed: {
    title: function() {
      return this.$route.meta.title;
    }
  },
  data() {
    return {
      active: 1,
      isweixin: false
    };
  },
  mounted(options) {}
};
</script>
<style scoped lang="less">
.tou{
  position:relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height:40px;
}
.icon{
  position:absolute;
  left: 0;
  display: flex;
}
.icon div{
  padding:0 10px;
  display: flex;
}
.t{
  margin: 0 auto;
  color: #323233;
  font-weight: 500;
  font-size: .8rem;
}
.van-nav-bar__left {
  left: 0;
  width: 50px;
}
.van-nav-bar .van-icon {
  color: #f2826a;
  vertical-align: middle;
  font-size: 24px;
}
</style>
